<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div class="charts-section">
	<div class="chart-filter">
		<globalictcc-dropdown
			label="Functional unit"
			[options]="functionalUnitsOptions"
			[paginated]="true"
			[hasMore]="hasMoreFunctionalUnits"
			[(ngModel)]="selectedFunctionalUnit"
			(handleSelectionChange)="onFunctionalUnitSelect($event)"
			(loadMore)="onFunctionalUnitsScrolledToBottom()"
		/>

		<globalictcc-button
			label="Apply"
			(handleClick)="onApply()"
			[disabled]="!selectedFunctionalUnit"
		/>
	</div>

	@if (authorizationService.canSee(grants.softwareCarbonIntensitySciScoreOfTheApps)) {
		@let worst10Emissions = worst10Emissions$ | async;

		<div class="chart-panel">
			<globalictcc-chart
				#worst10EmissionsChart
				chartType="barY"
				[data]="worst10Emissions?.data?.chart"
				[isLoading]="worst10Emissions?.isLoading ?? false"
				[hasError]="worst10Emissions?.hasError || worst10Emissions?.data?.hasError"
				[isGradient]="true"
				(handleChartRefresh)="onWorst10EmissionsChartRefresh()"
			/>

			<div class="chart-actions">
				<globalictcc-button
					label="Export chart"
					[textOnly]="true"
					iconName="download"
					(handleClick)="
						onExportChart(worst10EmissionsChart.instance, 'software_worst_10_emissions')
					"
				/>
			</div>
		</div>
	}

	@if (authorizationService.canSee(grants.softwareCarbonIntensityApplicationEfficiency)) {
		@let greenScore = greenScore$ | async;

		<div class="chart-panel">
			<globalictcc-chart
				#greenScoreChart
				chartType="scatter"
				[data]="greenScore?.data?.chart"
				[isLoading]="greenScore?.isLoading ?? false"
				[hasError]="greenScore?.hasError || greenScore?.data?.hasError"
				[configOverrides]="scatterOverrides"
				(handleChartRefresh)="onGreenScoreChartRefresh()"
			/>

			<div class="chart-actions">
				<globalictcc-button
					label="Export chart"
					[textOnly]="true"
					iconName="download"
					(handleClick)="onExportChart(greenScoreChart.instance, 'software_green_score')"
				/>
			</div>
		</div>
	}
</div>
